import api from './api';

const resource = 'ImageLibraryAdmin/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const upsert = async (formData) => {
  return await api.post(resource + 'Upsert', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteById = async (id) => {
  return await api.post(resource + 'Delete?id=' + id);
};

// Library kaydının tag setini topluca replace eder. tags: string[]
export const replaceTags = async (libraryimageid, tags) => {
  return await api.post(resource + 'Tags/Replace', {
    libraryimageid,
    tags,
  });
};

const imageLibraryAdminApi = { list, upsert, deleteById, replaceTags };

export default imageLibraryAdminApi;
